import React, { useContext } from 'react';
import { getIntl } from '../../../utils/intl';
import Select from '../../v2BaseComponents/Inputs/Select';
import { SelectOption } from '../../v2BaseComponents/Inputs/Select/types';
import { CenteredFormRow } from '../../v2BaseComponents/Form';
import { SelectCareTeamMemberTypeContext } from './SelectCareTeamMemberTypeContext';
import { CareTeamMemberType } from './types';

const intl = getIntl('CareTeamTypeSelect', {
    careTeamType: 'Care Team Type',
    careTeamTypePlaceholder: 'Select an option',
    support: 'Support',
    provider: 'Provider',
    insurance: 'Insurance',
    careTeamMemberType: 'Select Care Team Member Type',
});

const typeSelectOptions: SelectOption[] = [
    {
        label: intl('support'),
        value: 'support',
    },
    {
        label: intl('provider'),
        value: 'provider',
    },
    {
        label: intl('insurance'),
        value: 'insurance',
    },
];

export type CareTeamTypeSelectOwnProps = {
    value: string | null;
    isDisabled?: boolean;
};

export type CareTeamTypeSelectProps = CareTeamTypeSelectOwnProps;

const CareTeamTypeSelect: React.FC<CareTeamTypeSelectProps> = (props) => {
    const { selectCareTeamMemberType, areUpdatesDisabled } = useContext(SelectCareTeamMemberTypeContext);

    return (
        <CenteredFormRow>
            <Select
                selectOptions={typeSelectOptions}
                value={props.value}
                onChange={(value) => selectCareTeamMemberType(value as CareTeamMemberType | null)}
                title={intl('careTeamMemberType')}
                isDisabled={props.isDisabled || areUpdatesDisabled}
                testID="care-team-member-type-select"
            />
        </CenteredFormRow>
    );
};

export default React.memo(CareTeamTypeSelect);
